import styled from 'styled-components';
import colors from 'constants/colors';

export const OverviewContainer = styled.table`
  width: 100%;

  .date {
    width: 40%;
    padding-left: 16px;
  }

  .rooms {
    width: 40%;
  }

  .breakfasts {
    width: 20%;
    padding-right: 16px;
  }
`;

export const Row = styled.tr`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid ${colors.black5};
`;


export const NavigatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;

  /* @media only screen and (max-width: 1200px) {
    justify-content: center;
  } */
`;

export const Navigator = styled.div`
  color: ${colors.lightBlue};
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;

  /* @media only screen and (max-width: 1200px) {
    display: none;
  } */

  ${(props) => props.disabled ? `
    pointer-events:none;
    color: ${colors.dimGrey}
  `: null }
`;
